import { ComponentType, ReactElement, ReactNode, isValidElement } from "react";

export const isReactElement = (child: ReactNode): child is ReactElement =>
  isValidElement(child);

export const getDisplayName = <T>(Component: ComponentType<T>) =>
  Component.displayName || Component.name || "Component";
